import * as PropTypes from 'prop-types';

import {User} from 'constants/UserConstants';
import {Organization, ORGANIZATION_REQUEST, OrganizationRequest, Team} from 'orgs/OrganizationConstants';

export enum ReferralStatus {
  PENDING = 'pending',
  MEMBER = 'member',
}

interface OrgStatus {
  organizationId: string;
  status: ReferralStatus;
}

export interface Referral {
  email: string;
  user: User | null;
  createdAt: string;
  orgStatuses: Array<OrgStatus>;
}

export interface EntityStoreUser extends User {
  organizationIds?: Array<string>;
  organizations: Array<Organization>;
  teamIds?: Array<string>;
  teams: Array<Team>;
  currentUserInboundRequests: Array<OrganizationRequest>;
  currentUserOutboundRequests?: Array<OrganizationRequest>;
  pendingOrgInvites?: number;
  userOrgsInboundRequests: Array<OrganizationRequest>;
  referrals?: Array<Referral>;
}

export const ENTITY_STORE_USER_SHAPE = {
  avatar_url: PropTypes.string.isRequired,
  currentUserInboundRequests: PropTypes.arrayOf(ORGANIZATION_REQUEST),
  handle: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  url_identifier: PropTypes.string.isRequired,
  pendingOrgInvites: PropTypes.number,
  userOrgsInboundRequests: PropTypes.arrayOf(ORGANIZATION_REQUEST),
};
